import { render, staticRenderFns } from "./ViewLicense.vue?vue&type=template&id=156ea110&scoped=true"
import script from "./ViewLicense.vue?vue&type=script&lang=js"
export * from "./ViewLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ea110",
  null
  
)

export default component.exports